import React from "react";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { OutlinedInput, Select as SelectField } from '@material-ui/core';
import FormHelperText from "@material-ui/core/FormHelperText";
import { TextField } from "@material-ui/core";
import { useTheme } from "@material-ui/styles"
import { ArrowDropDown } from "@material-ui/icons"
import { useSelector } from "react-redux"
import config from "../../config"
import { useAutoCompleteStyles } from "../../utils"

function Select({ formik, name, label, options, value, disabled, setAutoFillState, withTextField, ...rest }) {
  const { theme: { colors, bgColors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = useAutoCompleteStyles(bgColors, colors)()
  return (
    <FormControl id="name-label" fullWidth variant="outlined" disabled={disabled} className={``}
      error={formik?.touched[name] && Boolean(formik?.errors[name])} {...rest}>
      <InputLabel id="name-label" style={{fontSize: rest.size === 'small' && 12, color: colors.colorText}}>{label}</InputLabel>
      <SelectField
        name={name && name}
        labelId="name-label"
        id="name"  
        IconComponent={(props) => (
          <ArrowDropDown {...props} style={{ color: colors.colorText }} />
        )}
        input={
          <OutlinedInput
            label={label}
            classes={{ root: isContrast ? classes.outlinedRoot : '' }}
          />
        }
        style={{ backgroundColor: bgColors.bgPrimary200, color: colors.colorText, fontSize: rest.size === 'small' && 12}}
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: bgColors.bgPrimary200,
              color: colors.colorText,
              borderRadius: '10px',
            },
          },
        }}
        fullWidth
        value={value ? value : name && formik?.values[name]}
        onChange={formik?.handleChange}
        onClick={() => setAutoFillState && setAutoFillState(null)}
        labelWidth={rest.size === 'small' ? label.length * 6 : label.length * 8}
        {...rest}
      >
        {options.map((o) => (
          <MenuItem key={o.id} value={o.id}>
            {o.name}
          </MenuItem>
        ))}
        {withTextField &&
          <MenuItem dense={true} className={`p-1`}>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
            />
          </MenuItem>
        }
      </SelectField>
      <FormHelperText id="outlined-adornment-password">{formik?.touched[name] && formik?.errors[name]}</FormHelperText>
    </FormControl>
  )
}

export default Select;
